webpackJsonp([2,0],[
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _vue = __webpack_require__(51);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _App = __webpack_require__(45);
	
	var _App2 = _interopRequireDefault(_App);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	new _vue2.default({
	  el: '#app',
	  render: function render(h) {
	    return h(_App2.default);
	  }
	});

/***/ },
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = [{
	  'city': 'Arizona',
	  'name': 'Cardinals',
	  'abr': 'ARI',
	  'conf': 'NFC',
	  'div': 'West'
	}, {
	  'city': 'Atlanta',
	  'name': 'Falcons',
	  'abr': 'ATL',
	  'conf': 'NFC',
	  'div': 'South'
	}, {
	  'city': 'Baltimore',
	  'name': 'Ravens',
	  'abr': 'BAL',
	  'conf': 'AFC',
	  'div': 'North'
	}, {
	  'city': 'Buffalo',
	  'name': 'Bills',
	  'abr': 'BUF',
	  'conf': 'AFC',
	  'div': 'EAST'
	}, {
	  'city': 'Carolina',
	  'name': 'Panthers',
	  'abr': 'CAR',
	  'conf': 'NFC',
	  'div': 'South'
	}, {
	  'city': 'Cincinati',
	  'name': 'Bengals',
	  'abr': 'CIN',
	  'conf': 'AFC',
	  'div': 'North'
	}, {
	  'city': 'Chicago',
	  'name': 'Bears',
	  'abr': 'CIN',
	  'conf': 'NFC',
	  'div': 'North'
	}, {
	  'city': 'Cleveland',
	  'name': 'Browns',
	  'abr': 'CLE',
	  'conf': 'AFC',
	  'div': 'North'
	}, {
	  'city': 'Dallas',
	  'name': 'Cowboys',
	  'abr': 'DAL',
	  'conf': 'NFC',
	  'div': 'East'
	}, {
	  'city': 'Denver',
	  'name': 'Broncos',
	  'abr': 'DEN',
	  'conf': 'AFC',
	  'div': 'West'
	}, {
	  'city': 'Detroit',
	  'name': 'Lions',
	  'abr': 'DET',
	  'conf': 'NFC',
	  'div': 'North'
	}, {
	  'city': 'Green Bay',
	  'name': 'Packers',
	  'abr': 'GB',
	  'conf': 'NFC',
	  'div': 'North'
	}, {
	  'city': 'Houston',
	  'name': 'Texans',
	  'abr': 'HOU',
	  'conf': 'AFC',
	  'div': 'South'
	}, {
	  'city': 'Indianapolis',
	  'name': 'Colts',
	  'abr': 'IND',
	  'conf': 'AFC',
	  'div': 'South'
	}, {
	  'city': 'Jacksonville',
	  'name': 'Jaquars',
	  'abr': 'JAX',
	  'conf': 'AFC',
	  'div': 'South'
	}, {
	  'city': 'Kansas City',
	  'name': 'Chiefts',
	  'abr': 'KC',
	  'conf': 'AFC',
	  'div': 'West'
	}, {
	  'city': 'Miami',
	  'name': 'Dolphins',
	  'abr': 'MIA',
	  'conf': 'AFC',
	  'div': 'East'
	}, {
	  'city': 'Minnesota',
	  'name': 'Vikings',
	  'abr': 'MIN',
	  'conf': 'AFC',
	  'div': 'North'
	}, {
	  'city': 'New England',
	  'name': 'Patriots',
	  'abr': 'NE',
	  'conf': 'AFC',
	  'div': 'East'
	}, {
	  'city': 'New Orleans',
	  'name': 'Saints',
	  'abr': 'NO',
	  'conf': 'NFC',
	  'div': 'South'
	}, {
	  'city': 'New York',
	  'name': 'Giants',
	  'abr': 'NYG',
	  'conf': 'NFC',
	  'div': 'East'
	}, {
	  'city': 'New York',
	  'name': 'Jets',
	  'abr': 'NYJ',
	  'conf': 'AFC',
	  'div': 'East'
	}, {
	  'city': 'Oakland',
	  'name': 'Raiders',
	  'abr': 'OAK',
	  'conf': 'AFC',
	  'div': 'West'
	}, {
	  'city': 'Philidelphia',
	  'name': 'Eagles',
	  'abr': 'PHI',
	  'conf': 'NFC',
	  'div': 'East'
	}, {
	  'city': 'Pittsburgh',
	  'name': 'Steelers',
	  'abr': 'PIT',
	  'conf': 'AFC',
	  'div': 'North'
	}, {
	  'city': 'San Diego',
	  'name': 'Chargers',
	  'abr': 'SD',
	  'conf': 'AFC',
	  'div': 'West'
	}, {
	  'city': 'Seattle',
	  'name': 'Seahawks',
	  'abr': 'SEA',
	  'conf': 'NFC',
	  'div': 'West'
	}, {
	  'city': 'San Francisco',
	  'name': '49ers',
	  'abr': 'SF',
	  'conf': 'NFC',
	  'div': 'West'
	}, {
	  'city': 'St. Louis',
	  'name': 'Rams',
	  'abr': 'STL',
	  'conf': 'NFC',
	  'div': 'West'
	}, {
	  'city': 'Tampa Bay',
	  'name': 'Buccaneers',
	  'abr': 'TB',
	  'conf': 'NFC',
	  'div': 'South'
	}, {
	  'city': 'Tennessee',
	  'name': 'Titants',
	  'abr': 'TEN',
	  'conf': 'AFC',
	  'div': 'South'
	}, {
	  'city': 'Washington',
	  'name': 'Redskins',
	  'abr': 'WAS',
	  'conf': 'NFC',
	  'div': 'East'
	}];

/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _assign = __webpack_require__(14);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	var _Select = __webpack_require__(46);
	
	var _Select2 = _interopRequireDefault(_Select);
	
	var _Sample = __webpack_require__(47);
	
	var _Sample2 = _interopRequireDefault(_Sample);
	
	var _teams = __webpack_require__(10);
	
	var _teams2 = _interopRequireDefault(_teams);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'app',
	  components: {
	    BulmaSelect: _Select2.default,
	    Sample: _Sample2.default
	  },
	  data: function data() {
	    return {
	      selection: undefined,
	      options: _teams2.default,
	      searched: (0, _assign2.default)([], _teams2.default)
	    };
	  },
	
	  methods: {
	    search: function search(text) {
	      var down = text.toLowerCase();
	
	      this.searched = this.options.filter(function (i) {
	        return i.name.toLowerCase().includes(down);
	      });
	    }
	  }
	};

/***/ },
/* 12 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'bulma-select',
	  props: {
	    placeholder: {
	      type: String,
	      default: 'Select...'
	    },
	
	    options: {
	      type: Array,
	      default: function _default() {
	        return [];
	      }
	    },
	
	    label: {
	      type: String
	    },
	
	    value: {
	      type: null,
	      default: null
	    },
	
	    search: {
	      type: Boolean,
	      default: false
	    },
	
	    maxItems: {
	      type: Number,
	      default: 5
	    }
	  },
	  data: function data() {
	    return {
	      opened: false,
	      searchField: '',
	      saveSearchField: '',
	      selected: undefined
	    };
	  },
	
	  computed: {
	    containerClasses: function containerClasses() {
	      return ['bulma-select__container', { 'bulma-select__container--active': this.opened }];
	    },
	    placeholderClasses: function placeholderClasses() {
	      return ['bulma-select__placeholder input', { 'is-hovered': this.opened }];
	    },
	    optionsClasses: function optionsClasses() {
	      return [{ 'is-hovered': this.opened }, 'bulma-select__options'];
	    },
	    optionsStyles: function optionsStyles() {
	      var styles = {};
	
	      if (this.options.length > this.maxItems) {
	        styles.height = 35 * this.maxItems + 'px';
	      }
	
	      return styles;
	    },
	    selectedItem: function selectedItem() {
	      return this.options[this.selected];
	    },
	    textSelected: function textSelected() {
	      if (this.options[this.selected] === undefined) {
	        return '';
	      }
	
	      return this.label !== undefined ? this.selectedItem[this.label] : this.selectedItem;
	    }
	  },
	
	  methods: {
	    toggleOpened: function toggleOpened() {
	      this.opened ? this.close() : this.open();
	    },
	    open: function open() {
	      if (this.opened) {
	        return;
	      }
	
	      this.searchField = this.saveSearchField;
	      this.inputSearch();
	      this.opened = true;
	      this.$refs.search.focus();
	    },
	    close: function close() {
	      if (!this.opened) {
	        return;
	      }
	
	      this.opened = false;
	      this.saveSearchField = this.searchField;
	      this.searchField = this.textSelected;
	      this.$refs.search.blur();
	    },
	    selectVModel: function selectVModel() {
	      if (this.options.indexOf(this.value) === -1) {
	        return;
	      }
	      this.selected = this.options.indexOf(this.value);
	    },
	    selectOption: function selectOption(i) {
	      this.selected = i;
	      this.searchField = this.textSelected;
	      this.saveSearchField = '';
	
	      this.$emit('input', this.options[this.selected]);
	    },
	    inputSearch: function inputSearch() {
	      this.$emit('type', this.searchField);
	    }
	  },
	
	  watch: {
	    value: function value() {
	      this.selectVModel();
	    },
	    options: function options(_, old) {
	      var i = this.options.indexOf(old[this.selected]);
	      if (i > -1) {
	        this.selected = i;
	      }
	    }
	  },
	  created: function created() {
	    this.selectVModel();
	  }
	};

/***/ },
/* 13 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'sample',
	  props: {
	    title: String,
	    desc: String
	  },
	  data: function data() {
	    return {
	      active: 0
	    };
	  },
	
	  methods: {
	    change: function change(i) {
	      this.active = i;
	    }
	  }
	};

/***/ },
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */,
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */,
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 43 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 44 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 45 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(42)
	
	/* script */
	__vue_exports__ = __webpack_require__(11)
	
	/* template */
	var __vue_template__ = __webpack_require__(48)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 46 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(44)
	
	/* script */
	__vue_exports__ = __webpack_require__(12)
	
	/* template */
	var __vue_template__ = __webpack_require__(50)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 47 */
/***/ function(module, exports, __webpack_require__) {

	var __vue_exports__, __vue_options__
	var __vue_styles__ = {}
	
	/* styles */
	__webpack_require__(43)
	
	/* script */
	__vue_exports__ = __webpack_require__(13)
	
	/* template */
	var __vue_template__ = __webpack_require__(49)
	__vue_options__ = __vue_exports__ = __vue_exports__ || {}
	if (
	  typeof __vue_exports__.default === "object" ||
	  typeof __vue_exports__.default === "function"
	) {
	__vue_options__ = __vue_exports__ = __vue_exports__.default
	}
	if (typeof __vue_options__ === "function") {
	  __vue_options__ = __vue_options__.options
	}
	
	__vue_options__.render = __vue_template__.render
	__vue_options__.staticRenderFns = __vue_template__.staticRenderFns
	
	module.exports = __vue_exports__


/***/ },
/* 48 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "hero is-primary is-fullheight",
	    attrs: {
	      "id": "app"
	    }
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "hero-body"
	  }, [_c('div', {
	    staticClass: "container"
	  }, [_c('h2', {
	    staticClass: "title"
	  }, [_vm._v("Examples")]), _vm._v(" "), _c('sample', {
	    attrs: {
	      "title": "Simple Select",
	      "desc": "Just a replace to the regular <select>"
	    }
	  }, [_c('template', {
	    slot: "result"
	  }, [_c('bulma-select', {
	    attrs: {
	      "label": "name",
	      "placeholder": "Select your team",
	      "options": _vm.options
	    }
	  })], 1), _vm._v(" "), _c('template', {
	    slot: "source"
	  }, [_vm._v("<bulma-select\n  label=\"name\"\n  placeholder=\"Select your team\"\n  v-model=\"selection\"\n  :options=\"options\">\n</bulma-select>")])], 2), _vm._v(" "), _c('sample', {
	    attrs: {
	      "title": "Select with search",
	      "desc": "Type to search in the options"
	    }
	  }, [_c('template', {
	    slot: "result"
	  }, [_c('bulma-select', {
	    attrs: {
	      "label": "name",
	      "placeholder": "Select your team",
	      "search": true,
	      "options": _vm.searched
	    },
	    on: {
	      "type": _vm.search
	    }
	  })], 1), _vm._v(" "), _c('template', {
	    slot: "source"
	  }, [_vm._v("<bulma-select\n  label=\"name\"\n  placeholder=\"Select your team\"\n  v-model=\"selection\"\n  @type=\"search\"\n  :search=\"true\"\n  :options=\"options\">\n</bulma-select>")])], 2), _vm._v(" "), _c('h2', {
	    staticClass: "title"
	  }, [_vm._v("Documentation")]), _vm._v(" "), _vm._m(1)], 1)]), _vm._v(" "), _vm._m(2)])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "hero-head"
	  }, [_c('header', {
	    staticClass: "nav"
	  }, [_c('div', {
	    staticClass: "container"
	  }, [_c('div', {
	    staticClass: "nav-center"
	  }, [_c('div', {
	    staticClass: "nav-item"
	  }, [_c('h1', {
	    staticClass: "title is-marginless"
	  }, [_vm._v("Vue Bulma Select")]), _vm._v(" "), _c('h2', {
	    staticClass: "title is-6"
	  }, [_vm._v("Select components using Bulma as CSS framework")])])])])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "sample__container"
	  }, [_c('h3', {
	    staticClass: "title is-4"
	  }, [_vm._v("<bulma-select>")]), _vm._v(" "), _c('h4', {
	    staticClass: "title is-6"
	  }, [_vm._v("Properties")]), _vm._v(" "), _c('table', {
	    staticClass: "table"
	  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Name")]), _vm._v(" "), _c('th', [_vm._v("Type")]), _vm._v(" "), _c('th', [_vm._v("Description")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("v-model")]), _vm._v(" "), _c('td', [_vm._v("Any")]), _vm._v(" "), _c('td', [_vm._v("Value selected.")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("placeholder")]), _vm._v(" "), _c('td', [_vm._v("String")]), _vm._v(" "), _c('td', [_vm._v("Text that will be used as placeholder in the select.")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("options")]), _vm._v(" "), _c('td', [_vm._v("Array[Any]")]), _vm._v(" "), _c('td', [_vm._v("Select options.")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("label")]), _vm._v(" "), _c('td', [_vm._v("String")]), _vm._v(" "), _c('td', [_vm._v("If an Array of objects is passed as options, label is the object key that will be displayed.")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("search")]), _vm._v(" "), _c('td', [_vm._v("Boolean")]), _vm._v(" "), _c('td', [_vm._v("If it has search or not.")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("maxItems")]), _vm._v(" "), _c('td', [_vm._v("Number")]), _vm._v(" "), _c('td', [_vm._v("The max number of options that will be displayed.")])])])]), _vm._v(" "), _c('h4', {
	    staticClass: "title is-6"
	  }, [_vm._v("Events")]), _vm._v(" "), _c('table', {
	    staticClass: "table"
	  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Name")]), _vm._v(" "), _c('th', [_vm._v("Description")]), _vm._v(" "), _c('th', [_vm._v("Params")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("type")]), _vm._v(" "), _c('td', [_vm._v("When the search field recive input.")]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("text: String")]), _vm._v(" - the text inputed")])])])]), _vm._v(" "), _c('h4', {
	    staticClass: "title is-6"
	  }, [_vm._v("Slots")]), _vm._v(" "), _c('table', {
	    staticClass: "table"
	  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Name")]), _vm._v(" "), _c('th', [_vm._v("Description")])])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("no-results")]), _vm._v(" "), _c('td', [_vm._v("When there is no options its displayed on the options container.")])])])])])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "hero-foot"
	  }, [_c('div', {
	    staticClass: "container"
	  }, [_c('div', {
	    staticClass: "has-text-centered is-fullwidth"
	  }, [_vm._v("\n          Built by "), _c('a', {
	    attrs: {
	      "href": "https://github.com/gabrielcorado"
	    }
	  }, [_vm._v("@gabrielcorado")])])])])
	}]}

/***/ },
/* 49 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "sample__container"
	  }, [_c('h3', {
	    staticClass: "title is-4 is-marginless"
	  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('h4', {
	    staticClass: "title is-6"
	  }, [_vm._v(_vm._s(_vm.desc))]), _vm._v(" "), _c('div', {
	    staticClass: "tabs is-boxed is-marginless"
	  }, [_c('ul', [_c('li', {
	    class: [_vm.active === 0 ? 'is-active' : '']
	  }, [_c('a', {
	    on: {
	      "click": function($event) {
	        _vm.change(0)
	      }
	    }
	  }, [_c('span', [_vm._v("Result")])])]), _vm._v(" "), _c('li', {
	    class: [_vm.active === 1 ? 'is-active' : '']
	  }, [_c('a', {
	    on: {
	      "click": function($event) {
	        _vm.change(1)
	      }
	    }
	  }, [_c('span', [_vm._v("Source")])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "sample__tabs-body"
	  }, [_c('transition', {
	    attrs: {
	      "mode": "out-in",
	      "name": "slide-fade"
	    }
	  }, [(_vm.active === 0) ? _vm._t("result") : (_vm.active === 1) ? _c('div', [_c('pre', [_c('code', [_vm._t("source")], 2)])]) : _vm._e()], 2)], 1)])
	},staticRenderFns: []}

/***/ },
/* 50 */
/***/ function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    class: _vm.containerClasses
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.searchField),
	      expression: "searchField"
	    }],
	    ref: "search",
	    class: _vm.placeholderClasses,
	    attrs: {
	      "readonly": !_vm.search,
	      "placeholder": _vm.placeholder
	    },
	    domProps: {
	      "value": _vm._s(_vm.searchField)
	    },
	    on: {
	      "blur": _vm.close,
	      "input": [function($event) {
	        if ($event.target.composing) { return; }
	        _vm.searchField = $event.target.value
	      }, _vm.inputSearch],
	      "click": function($event) {
	        if ($event.target !== $event.currentTarget) { return; }
	        _vm.toggleOpened($event)
	      }
	    }
	  }), _vm._v(" "), _c('transition', {
	    attrs: {
	      "name": "vuebulmaselect-slide-fade"
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (_vm.opened),
	      expression: "opened"
	    }],
	    class: _vm.optionsClasses,
	    style: (_vm.optionsStyles)
	  }, [(_vm.options.length === 0) ? [_c('button', {
	    staticClass: "button is-white bulma-select__option",
	    attrs: {
	      "disabled": ""
	    }
	  }, [_vm._t("no-results", [_vm._v("No options found.")])], 2)] : _vm._l((_vm.options), function(option, i) {
	    return _c('button', {
	      class: ['button is-white', _vm.selected === i ? 'is-info' : '', 'bulma-select__option'],
	      on: {
	        "click": function($event) {
	          _vm.selectOption(i)
	        }
	      }
	    }, [_vm._v("\n          " + _vm._s(_vm.label !== undefined ? option[_vm.label] : option) + "\n        ")])
	  })], 2)])], 1)
	},staticRenderFns: []}

/***/ }
]);


// WEBPACK FOOTER //
// static/js/app.9a6b47bff197e24f4161.js